export default __webpack_public_path__ + "static/media/image-17.2b4c5c27.webp";